import { MapPin, Phone, Mail, Facebook, Clock } from "lucide-react";
import { BRAND, whatsappLink } from "../../data";
import { SectionHeading, Reveal } from "./Shared";

const HOURS = [
  { d: "Monday – Friday", h: "10:00 – 21:00" },
  { d: "Saturday", h: "10:00 – 20:00" },
  { d: "Sunday", h: "By appointment" },
];

export const Contact = () => {
  const mapSrc = `https://maps.google.com/maps?q=${encodeURIComponent(
    BRAND.mapQuery
  )}&z=15&output=embed`;

  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-28 px-6 bg-[#2d3a1f]"
    >
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="Visit Royale"
          title="Find Us & Book"
          subtitle="We're in the heart of Sants-Montjuïc, Barcelona. Message us on WhatsApp to reserve your moment of calm."
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mt-16">
          <Reveal className="space-y-8">
            <div className="space-y-6">
              <ContactRow icon={<MapPin size={20} />} label="Address" value={BRAND.address} />
              <a
                data-testid="contact-phone"
                href={whatsappLink()}
                target="_blank"
                rel="noopener noreferrer"
                className="block"
              >
                <ContactRow icon={<Phone size={20} />} label="WhatsApp" value={BRAND.phoneDisplay} hover />
              </a>
              <a data-testid="contact-email" href={`mailto:${BRAND.email}`} className="block">
                <ContactRow icon={<Mail size={20} />} label="Email" value={BRAND.email} hover />
              </a>
              <a
                data-testid="contact-facebook"
                href={BRAND.facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="block"
              >
                <ContactRow icon={<Facebook size={20} />} label="Facebook" value={BRAND.facebook} hover />
              </a>
            </div>

            <div className="border-t border-[#b89d62]/20 pt-8">
              <div className="flex items-center gap-3 mb-5">
                <Clock size={18} className="text-[#b89d62]" />
                <span className="eyebrow">Opening Hours</span>
              </div>
              <ul className="space-y-3">
                {HOURS.map((row) => (
                  <li key={row.d} className="flex items-center justify-between">
                    <span className="text-[#faf9f6] font-light">{row.d}</span>
                    <span className="text-[#c9d3ca] font-light">{row.h}</span>
                  </li>
                ))}
              </ul>
            </div>

            <a
              data-testid="contact-whatsapp-cta"
              href={whatsappLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#b89d62] hover:bg-[#d4af37] text-[#151c0f] transition-colors duration-400 px-9 py-4 btn-label"
            >
              Book via WhatsApp
            </a>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="relative h-full min-h-[420px] border border-[#b89d62]/30">
              <iframe
                title="Royale location map"
                data-testid="contact-map"
                src={mapSrc}
                className="w-full h-full min-h-[420px] grayscale-[0.3] contrast-[1.05]"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

const ContactRow = ({ icon, label, value, hover }) => (
  <div className="flex items-start gap-4 group">
    <span className="mt-1 w-11 h-11 flex items-center justify-center border border-[#b89d62]/40 text-[#b89d62] shrink-0 group-hover:bg-[#b89d62] group-hover:text-[#151c0f] transition-colors duration-400">
      {icon}
    </span>
    <div>
      <p className="eyebrow !text-[#c9d3ca]">{label}</p>
      <p
        className={`font-serif-display text-xl mt-1 ${
          hover ? "text-[#faf9f6] group-hover:text-[#b89d62] transition-colors" : "text-[#faf9f6]"
        }`}
      >
        {value}
      </p>
    </div>
  </div>
);
